<template>
  <div class="mobile series series-accordion">
    <ul>
      <ul v-for="(serie,serie_id) in series" :key="serie_id" v-bind:class="'serie-' + serie_id">
        <h2 class="accordion"><serie-logo :serie="serie_id"/></h2>
        <ul>
          <li>

            <div class='serie-logo-bg'>
              <serie-logo :serie="serie_id"/>
            </div>
            <div class="wrapper">
              <div class='col series-main-bike'>
                <div v-for="(kind,ski) in serie.kinds" v-bind:class="'serie-kind kind-' + kind"></div>
              </div>
              <div class="col series-info">
                <h2 v-html="t('sr_' + serie_id + '_hd')"></h2>
                <p v-html="t('dsc_' + serie_id )"></p>
                <a :href="getLink(serie_id)" class="btn"><span v-translate="'sr_explore'"> </span>&nbsp;<span>{{serie_id}}</span></a>
              </div>
            </div>


          </li>
        </ul>
      </ul>
    </ul>
  </div>
</template>
<script>
  import SerieLogo from "../Graphics/SerieLogo";

  export default {
    name: 'HomePageBikesMobile',
    components: { SerieLogo  },
    mounted (){
      this.series = window.env.bikesSeries;
    },
    data () {
      return {
        series: {}
      }
    },
    methods: {
      t (text) { return translations[text]; },
      getLink(id) {
        return this.t('rt_bikes') + '/' + id;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomePage/BikesSeriesMobile.vue